declare namespace $ {

	type $shm_wordstat_task_list_head__title_shm_wordstat_task_list_1 = $mol_type_enforce<
		ReturnType< $shm_wordstat_task_list['title'] >
		,
		ReturnType< $shm_wordstat_task_list_head['title'] >
	>
	type $shm_wordstat_task_list_head__title_uri_shm_wordstat_task_list_2 = $mol_type_enforce<
		ReturnType< $shm_wordstat_task_list['tasks_uri'] >
		,
		ReturnType< $shm_wordstat_task_list_head['title_uri'] >
	>
	type $shm_wordstat_task_list_head__search_showed_shm_wordstat_task_list_3 = $mol_type_enforce<
		ReturnType< $shm_wordstat_task_list['search_showed'] >
		,
		ReturnType< $shm_wordstat_task_list_head['search_showed'] >
	>
	type $shm_wordstat_task_list_head__filter_shm_wordstat_task_list_4 = $mol_type_enforce<
		ReturnType< $shm_wordstat_task_list['filter'] >
		,
		ReturnType< $shm_wordstat_task_list_head['filter'] >
	>
	type $shm_wordstat_task_list_head__add_shm_wordstat_task_list_5 = $mol_type_enforce<
		ReturnType< $shm_wordstat_task_list['add'] >
		,
		ReturnType< $shm_wordstat_task_list_head['add'] >
	>
	type $shm_wordstat_task_list_head__Close_shm_wordstat_task_list_6 = $mol_type_enforce<
		any
		,
		ReturnType< $shm_wordstat_task_list_head['Close'] >
	>
	type $shm_wordstat_task_list_head__Settings_shm_wordstat_task_list_7 = $mol_type_enforce<
		any
		,
		ReturnType< $shm_wordstat_task_list_head['Settings'] >
	>
	export class $shm_wordstat_task_list extends $shm_service_task_list {
		search_showed( ): boolean
		filter( next?: string ): string
		task_add_new( next?: any ): any
		task_id( next?: string ): string
		task_title_current( next?: string ): string
		focus_queries( next?: any ): any
		tasks_uri( ): string
		List_head( ): $shm_wordstat_task_list_head
		tasks( ): readonly(any)[]
		task_title_rows( id: any): readonly(any)[]
		add( next?: ReturnType< $shm_wordstat_task_list['task_add_new'] > ): ReturnType< $shm_wordstat_task_list['task_add_new'] >
	}
	
}

//# sourceMappingURL=list.view.tree.d.ts.map